export function parsePipelineVersion(version: string): number {
  const parsed = Number.parseFloat(version);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}
